import { Language } from '../../lang/Language'

export class CantCallNoBetError extends Error {
  constructor() {
    super(Language.strings.error.table.cantCallNoBet)
  }
}
